// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"0c4aa9dd","515":"b4c2a1a6"}[chunkId] + ".chunk.js";
};